if (!customElements.get('reviews-showcase-grid')) {
    class ReviewsShowcaseGrid extends HTMLElement {
        constructor() {
            super();
            this.button = this.querySelector('.reviews-showcase__more-button');
            this.handleClick = this.handleClick.bind(this);
        }

        connectedCallback() {
            if (!this.button) return;
            this.button.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
            if (!this.button) return;
            this.button.removeEventListener('click', this.handleClick);
        }

        handleClick() {
            this.classList.add('is-expanded');
            this.button.setAttribute('aria-expanded', 'true');
        }
    }

    customElements.define('reviews-showcase-grid', ReviewsShowcaseGrid);
}